import React, { useContext } from 'react'
import { UserOutlined } from '@ant-design/icons'
import { Menu, Dropdown, Avatar, Badge } from 'antd'
import { FormattedMessage } from 'react-intl'

import { useAuth0 } from 'config/react-auth0-spa'
import { useLogout } from 'services/user'
import { useHistory } from 'react-router-dom'
import { apiContext } from 'services/ApiContext'
import { organizationTypes } from 'utils/enums'

import { RELEASE_VERSION } from 'utils/constants'
import styles from './style.module.scss'

const ProfileMenu = () => {
  const { loginWithRedirect } = useAuth0()
  const { user } = useContext(apiContext)
  const logout = useLogout()
  const { push } = useHistory()

  const menu = user ? (
    <Menu selectable={false}>
      <Menu.Item>
        <div className="rfq__widget__system-status__item">
          <strong>
            <FormattedMessage
              id="topBar.menu.hello"
              values={{ name: `${user.firstname} ${user.lastname}` }}
            />
          </strong>
          <div>
            <strong>
              <FormattedMessage id="topBar.version" values={{ version: RELEASE_VERSION }} />
            </strong>
          </div>
        </div>
      </Menu.Item>
      <Menu.Divider />
      <Menu.Item onClick={() => push('/report-bug')}>
        <i className="topbar__dropdownMenuIcon icmn-bug" /> <FormattedMessage id="reportBug" />
      </Menu.Item>
      <Menu.Divider />
      <Menu.Item onClick={() => push('/profile')}>
        <div className="rfq__widget__system-status__item">
          <strong>
            <FormattedMessage id="email" />:
          </strong>{' '}
          {user.email}
        </div>
      </Menu.Item>
      {user.group ? (
        <Menu.Item onClick={() => push('/group')}>
          <div className="rfq__widget__system-status__item">
            <strong>
              <FormattedMessage id="userAccount.group" />:
            </strong>{' '}
            {user.group.name} ({organizationTypes[user.group.organizationType]})
          </div>
        </Menu.Item>
      ) : null}
      <Menu.Divider />
      <Menu.Item onClick={() => push('/profile')}>
        <i className="topbar__dropdownMenuIcon icmn-user" />{' '}
        <FormattedMessage id="topBar.menu.editProfile" />
      </Menu.Item>
      <Menu.Item onClick={logout}>
        <i className="topbar__dropdownMenuIcon icmn-exit" /> <FormattedMessage id="logout" />
      </Menu.Item>
    </Menu>
  ) : (
    <Menu
      selectable={false}
      onClick={() => loginWithRedirect({ appState: { targetUrl: '/overview' } })}
    >
      <Menu.Item>
        <strong>
          <FormattedMessage id="topBar.menu.helloNoLogin" />
        </strong>
        <span className="nav-link">
          <FormattedMessage id="topBar.menu.noLoginNotice" />
        </span>
      </Menu.Item>
    </Menu>
  )

  return (
    <Dropdown overlay={menu} trigger={['click']}>
      <div className={styles.dropdown}>
        <Badge count={0 /* notifications */}>
          <Avatar
            className={styles.avatar}
            shape="circle"
            size="large"
            icon={<UserOutlined />}
            src={user && user.avatarURL}
          />
        </Badge>
      </div>
    </Dropdown>
  )
}

export default ProfileMenu
